import { useContext } from "react";

import { Card } from "@hdi-seguros/web-components.card";
import { Typography } from "antd";

import { QuotationInfoContext } from "../../contexts";

export const LoadSavedQuotationsCard = () => {
    const { savedQuotation } = useContext(QuotationInfoContext);

    return (
        <Card>
            <Typography>
                Aguarde un momento, estamos cargando la cotización { savedQuotation?.numero }
            </Typography>
        </Card>
    )
};